<template>
  <v-container class="wtb">
    <v-app>
      <HeaderBlock :zipcode="zipcode" @change-zipcode="changeZipCode" />

      <v-main>
        <v-container class="ma-0 pa-0 grey lighten-5">
          <SectionTabs @set-active-tab="setActiveTab" :active-tab="activeTab" />

          <template v-if="loading">
            <DataLoader :zipcode="zipcode" />
          </template>

          <div v-if="!loading" class="mainContent">
            <template v-if="activeTab === tabTypes.inHome">
              <Distributors :type="tabTypes.inHome" :items="inHomeData" :zipcode="zipcode" />
            </template>
            <template v-if="activeTab === tabTypes.retail">
              <Distributors :type="tabTypes.retail" :items="retailData" :zipcode="zipcode" />
            </template>
            <template v-if="activeTab === tabTypes.buyOnline">
              <BuyOnline />
            </template>
          </div>
        </v-container>
      </v-main>
    </v-app>
  </v-container>
</template>

<script>
import SectionTabs from "@/components/SectionTabs";
import DataLoader from "@/components/DataLoader";
import BuyOnline from "@/components/BuyOnline";
import Distributors from "@/components/Distributors";
import HeaderBlock from "@/components/HeaderBlock";
import tabTypes from "@/utils/tabTypes";
import { getInHomeData, getRetailData } from "@/api/ApiService";

export default {
  name: "App",

  components: {
    BuyOnline,
    Distributors,
    DataLoader,
    SectionTabs,
    HeaderBlock,
  },

  data() {
    return {
      tabTypes: tabTypes,
      activeTab: tabTypes.retail,
      retailData: [],
      inHomeData: [],
      zipcode: "93030",
      loading: false,
      errors: [],
    };
  },

  created() {
    this.getDefaultZipCode();

    if (this.$route.params.tab) {
      for (let value of Object.values(tabTypes)) {
        if (value === this.$route.params.tab) {
          this.activeTab = value;
          break;
        }
      }
    }
  },

  watch: {
    zipcode: function () {
      if (this.zipcode.length > 4) {
        this.getData();
      }
    },
  },

  async mounted() {
    this.getData();
  },

  methods: {
    setActiveTab: function (tab) {
      this.activeTab = tab;
      this.moveTo('home', this.activeTab, this.zipcode)
    },

    getDefaultZipCode: function () {
      if (this.$route.params.zipcode) {
        this.zipcode = this.$route.params.zipcode;
      } else {
        const rawCookie = document.cookie.replace(/(?:(?:^|.*;\s*)PostalCodeLookup\s*\=\s*([^;]*).*$)|^.*$/, "$1");
        if (document.cookie.indexOf("PostalCodeLookup=") >= 0) {
          this.zipcode = rawCookie.substr(rawCookie.length - 5);
        } else {
          this.zipcode = 93030;
        }
      }

    },

    changeZipCode: function (zipcode) {
      this.zipcode = zipcode;
      this.moveTo('home', this.activeTab, this.zipcode)
    },

    moveTo: function (name, tab, zipcode) {
      this.$router.push({name: name, params: {tab: tab, zipcode: zipcode}}).catch(() => {});
    },

    calcDistance: function (targetZip = '', currentZip = '') {
      const track = Array(currentZip.length + 1).fill(null).map(() =>
        Array(targetZip.length + 1).fill(null));
      for (let i = 0; i <= targetZip.length; i += 1) {
        track[0][i] = i;
      }
      for (let j = 0; j <= currentZip.length; j += 1) {
        track[j][0] = j;
      }
      for (let j = 1; j <= currentZip.length; j += 1) {
        for (let i = 1; i <= targetZip.length; i += 1) {
          const indicator = targetZip[i - 1] === currentZip[j - 1] ? 0 : 1;
          track[j][i] = Math.min(
            track[j][i - 1] + 1, // deletion
            track[j - 1][i] + 1, // insertion
            track[j - 1][i - 1] + indicator // substitution
          );
        }
      }
      return track[currentZip.length][targetZip.length];
    },

    processItems: function (data) {
      return Array.isArray(data) ? data.map((item) => {
        return {
          ...item,
          matchScore: this.calcDistance(this.zipcode.toString(), item.StorePostalCode)
        }
      }).sort(function (a, b) {
        return a.matchScore - b.matchScore;
      }) : [];
    },

    async getData() {
      this.loading = true;

      const [retailData, inHomeData] = await Promise.all([getRetailData(this.zipcode), getInHomeData(this.zipcode)]);

      this.retailData = this.processItems(retailData);
      this.inHomeData = this.processItems(inHomeData);

      this.loading = false;
    },
  }
};
</script>

<style></style>